namespace $ {
	
	export enum $mol_si_prefix {
		y = -8,
		z = -7,
		a = -6,
		f = -5,
		p = -4,
		n = -3,
		µ = -2,
		m = -1,
		'' = 0,
		k = 1,
		M = 2,
		G = 3,
		T = 4,
		P = 5,
		E = 6,
		Z = 7,
		Y = 8,
	}
	
}
